export { record } from './record'
export { serializeNodeWithId, serializeDocument, SerializationContextStatus } from './serialize'
export { createElementsScrollPositions } from './elementsScrollPositions'



// WEBPACK FOOTER //
// ./node_modules/@datadog/browser-rum/src/domain/record/index.ts